<template>
  <div>
    <h1>Formulário x Opção</h1> <br>
    <form @submit.prevent="filtrarOpcoesPorFormularios()">
      <b-row>
        <div class="col-sm-3">
          <SGPFormAutocompleteComponent name="ctrl_formulario_id" v-model="filtro.ctrl_formulario_id"
            :listaDeOptions="listaDeFormularios" :optionLabel="'titulo'" :optionValue="'id'"
            :placeholder="loadingFormularios ? 'Carregando filtro Formulários...' : 'Formulário'"
            :somenteLeitura="loadingFormularios" :limpavel="true" v-validate="'required'"
            :error="validationErrors.first('ctrl_formulario_id')" data-vv-as="Formulário" />
        </div>

        <div class="col-sm-2 container-botoes">
          <SGPFormBotaoComponent type="submit">
            Filtrar
          </SGPFormBotaoComponent>
        </div>
      </b-row>
    </form>
    <SGPTabelaComponent v-if="listaDeOpcoesFormulario.length" :colunas="colunas" :dados="listagem"
      :usuarioPodeExcluir="false" :usuarioPodeEditar="false" :somenteLeitura="true">
    </SGPTabelaComponent>
    <SGPAlertaComponent v-else class="mt-3" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "FormularioOpcaoPage",

  data() {
    return {
      filtro: {
        ctrl_formulario_id: '',
      }
    }
  },

  created() {
    this.listarFormularios();
  },

  computed: {
    ...mapGetters('ctrlTarefasMobilidades', ['listaDeOpcoesFormulario', 'loadingFormulariosOpcoes']),
    ...mapGetters('formularios', ['listaDeFormularios', 'loadingFormularios']),

    listagem() {
      return this.listaDeOpcoesFormulario
        .map(item => {
          return item;
        });
    },

    colunas() {
      return [
        {
          key: 'opcao',
          label: 'Opção',
          sortable: false
        },
      ]
    }
  },
  methods: {
    ...mapActions('ctrlTarefasMobilidades', [
      'recuperarOpcoesPorFormulario'
    ]),

    ...mapActions('formularios', ['listarFormularios']),

    filtrarOpcoesPorFormularios() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.recuperarOpcoesPorFormulario(this.filtro);
        }
      });
    }
  }
};

</script>